import { useUserRole } from "components/partner-access/hooks/usePartnerAccess"

export const useSendMessagePath = () => {
  const { isPartnerAccessingAccount } = useUserRole()
  return isPartnerAccessingAccount ? "/talk-to-carrot/care-navigation/send-a-message" : "/messages"
}
